import MainLayout from "./MainLayout";

import "./MainLayout.scss";

export default MainLayout;